import React from "react";
import RoutingManager from "./routes/RoutingManager";
import { QueryClientProvider, QueryClient } from "react-query";
import { Provider } from "react-redux";
import { store, persistor } from "./redux/store";
import { PersistGate } from "redux-persist/integration/react";
import { useInitializeEnv } from "@utils/hooks/service/useInitializeEnv";
import ContainerProvider from "./redux/containers/ContainerProvider";
import AdminErrorBoundary from "@utils/templates/AdminErrorBoundary";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0, // 요청 실패 시 재요청 횟 수
      refetchOnWindowFocus: false, // widnow가 다시 포커스 되었을 때 재요청을 보낼 것인지
    },
  },
});

export default function App() {
  useInitializeEnv();

  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <ContainerProvider>
            <AdminErrorBoundary>
              <RoutingManager />
            </AdminErrorBoundary>
          </ContainerProvider>
        </PersistGate>
      </Provider>
    </QueryClientProvider>
  );
}
